import { type CSSProperties, type FC } from 'react';
import Lottie from 'lottie-react';
import { cn } from '@shared/lib/utils';
import loadingAnimation from '../../assets/animations/loading.json';

interface LoaderProps {
  className?: string;
  size?: number;
  style?: CSSProperties;
}

/**
 * Универсальный индикатор загрузки на базе общей анимации.
 * Можно переиспользовать на любых шагах, при необходимости меняя размеры.
 */
export const Loader: FC<LoaderProps> = ({ className, size = 160, style }) => {
  return (
    <div className={cn('flex items-center justify-center', className)}>
      <Lottie
        animationData={loadingAnimation}
        className="loader-animation"
        loop
        style={{ width: size, height: size, ...style }}
        aria-label="индикатор загрузки"
      />
    </div>
  );
};
